import { render, staticRenderFns } from "./MainNavigationItemV2.vue?vue&type=template&id=c88d8eb2&"
import script from "./MainNavigationItemV2.vue?vue&type=script&lang=js&"
export * from "./MainNavigationItemV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports